import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=741a8d29&scoped=true"
import script from "./Get.vue?vue&type=script&lang=js"
export * from "./Get.vue?vue&type=script&lang=js"
import style0 from "./Get.vue?vue&type=style&index=0&id=741a8d29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741a8d29",
  null
  
)

export default component.exports